
$winW = $(window).width();
$winH = $(window).height();	
$scrolled = 0;
var scrollbar;
$navH = 120;
testEmail =    /^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i;
$form = $('#newsletter form');
$stopOrder = false;
$stopObject = false;
var optionScroll;
var $focusTimeout;
var proton;
var renderer;
var emitter;
var stats;
var canvas;
var context;
var $timer;
protonCreated = false;
$played = false;
$tasteVideo = false;
var tl;
$frame = 0;
$progress = 0;
$loaded = 0;
$offset = 0;
var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
if(isIE11){
	$('html').addClass('ie11');
	$('#main-scrollbar').hide().show(0);
}
Date.prototype.yyyymmdd = function() {
  var yyyy = this.getFullYear().toString();
  var mm = (this.getMonth()+1).toString(); // getMonth() is zero-based
  var dd  = this.getDate().toString();
  return yyyy + "" + (mm[1]?mm:"0"+mm[0]) + "" + (dd[1]?dd:"0"+dd[0]); // padding
};
var date = new Date();
var cartScroll;
var mobileMenuScroll;
var subscriptionScroll;
var $menuEnterIntent;
var $dropLeaveIntent;
Handlebars.registerHelper('eachSorted', function(context, options) {
	var fnCompare = function(a,b) {
	  return new Date(b) - new Date(a);
	};
	Object.keys(context).sort(fnCompare).forEach(function(key) {
	  ret = ret + options.fn({key: key, value: context[key]})
	});
})
Handlebars.registerHelper('iter', function(context, options) {
  var fn = options.fn, inverse = options.inverse;
  var ret = "";
  
  if(context && context.length > 0) {
    for(var i=0, j=context.length; i<j; i++) {
      ret = ret + fn($.extend({}, context[i], { i: i, iPlus1: i + 1 }));
    }
  } else {
    ret = inverse(this);
  }
  return ret;
});
Handlebars.registerHelper('ifCond', function (v1, operator, v2, options) {
    switch (operator) {
        case '==':
            return (v1 == v2) ? options.fn(this) : options.inverse(this);
        case '===':
            return (v1 === v2) ? options.fn(this) : options.inverse(this);
        case '!=':
            return (v1 != v2) ? options.fn(this) : options.inverse(this);
        case '!==':
            return (v1 !== v2) ? options.fn(this) : options.inverse(this);
        case '<':
            return (v1 < v2) ? options.fn(this) : options.inverse(this);
        case '<=':
            return (v1 <= v2) ? options.fn(this) : options.inverse(this);
        case '>':
            return (v1 > v2) ? options.fn(this) : options.inverse(this);
        case '>=':
            return (v1 >= v2) ? options.fn(this) : options.inverse(this);
        case '&&':
            return (v1 && v2) ? options.fn(this) : options.inverse(this);
        case '||':
            return (v1 || v2) ? options.fn(this) : options.inverse(this);
        default:
            return options.inverse(this);
    }
});
Handlebars.registerHelper('formatCurrency', function(value) {
    return (value * .01).toFixed(2);
});
function sortAscending(a, b) {
    var date1 = $(a).attr("data-exp");
    var date2 = $(b).attr("data-exp");
    return date1 > date2;
};
$shownOverlay = false;
var $overlayTimeout;
$(document).ready(function(){init();});
function init(){
	
	
	
	if($('div#ReCharge').length >= 1){
		$('div#ReCharge').before('<section class="three-col alt subs"><div id="header-spacer"></div><article class="double"><hgroup class="standard"><h1>My Subscriptions</h1></hgroup></article></section>');		
	}
	$('body').addClass('init');
	/*$(document).on('click', 'a[href!="#"]', function(e) {
		switch (event.which) {
		    case 1:
				newLocation = this.href;
				if(newLocation.includes('ceremonycoffee') || newLocation.includes('ceremony-coffee')){
					$('body').addClass('leaving');
					$('body').removeClass('loaded');
					$('body').removeClass('show-minicart');
					$('body').removeClass('show-overlay');
					clearTimeout($overlayTimeout);
					setTimeout(function(){
						$('body').removeClass('leaving');	
					},1000);
					setTimeout(function(){
						window.location = newLocation;	
					},1250);
					e.preventDefault();
					
				}
		        break;
		}
	});*/
	$('#enter-pass .reset').click(function(){
		$('#enter-pass').addClass('hidden');
		$('#reset-pass').removeClass('hidden');
	});
	$('.reset-password').click(function(){
		$('#enter-pass').addClass('hidden');
		$('#reset-pass').removeClass('hidden');
	});
	if($('#hero').length >= 1 && $('#hero article:nth-of-type(1)').hasClass('invert')){
		$('body').addClass('invert-nav');
	}
	if($('.single-job form .hidden.subject')){
		$('.single-job form .hidden.subject input[type=text]').val($('.text-header h1').html());
	}
	if($('.single-job form .hidden.location')){
		$('.single-job form .hidden.location input[type=text]').val($('.text-header .big').html());
	}

	if($(document).find('#mobile-alert').length >= 1){
		//if($(document).find('#mobile-alert').hasClass('cycle')){
			$(document).find('#mobile-alert .container > div').addClass('slide');
			$(document).find('#mobile-alert .container > div.primary').css({
				'background-color': $(document).find('#mobile-alert').attr('style')
			});
			if( $(document).find('#mobile-alert').hasClass('text-white') ){
				$(document).find('#mobile-alert .container > div.primary').addClass('text-white');
			}
			$(document).find('#mobile-alert .container').slick({
				arrows : false,
				autoplay : true,
				infinite : false,
				fade : false,
				slide : 'div.slide',
				speed : 600,
				slidesToShow:1,			
			});			
		//}
		//console.log('has alert');
	}	

	if($('#minicart #minicart-wrapper').length >= 1){


	} else{
		$.ajax({ 
			dataType:'jsonp', 
			url: 'https://shop.ceremonycoffee.com/cart.json', 
			success: function(d){ 
			   var templateSource   = $("#minicart-template").html(),
	                template = Handlebars.compile(templateSource),
	                cartHTML = template(d);
	           $('#minicart').html(cartHTML);
			
			       
				$(document).find('header.global nav.global #cart #count').html($('#minicart #minicart-items').attr('data-count'));
				if(parseInt($('#minicart #minicart-items').attr('data-count')) > 0){
					$(document).find('header.global nav.global #cart #status').removeClass('hide');
				}
			} 
		});		
	}
    $(document).on('click', '.remove-btn', function(e){
	    productId = $(this).attr('rel');
		 $.ajax({
		    type: "POST",
		    url: $(this).attr('data-url'),
		    success: function() { 
		       $('#minicart .item#'+productId).addClass('hide');
		       if($('#minicart .item:not(.hide)').length >= 1){
			       q = 0;
			       r = 0;
			       $('#minicart .item:not(.hide)').each(function(){
						myQuantity = parseInt($(this).attr('data-quantity'));
						q += myQuantity; 
						r++;
						$removeURL = $(this).find('.remove-btn').attr('data-url');
						var line = getQueryVariable($removeURL, 'line');
						var quantity = getQueryVariable($removeURL, 'quantity');
						// /cart/change?line=2&quantity=0
						var params = { 'line':r, 'quantity':'0'};
						var new_url = 'https://shop.ceremonycoffee.com/cart/change?' + jQuery.param(params);	
						$(this).find('.remove-btn').attr('data-url',new_url);			      
				      //$newURL = $removeURL.replace('line=');
				      $('header.global nav.global #cart #count').html(myQuantity);
			       });
			       
		       } else{
			      $('body').removeClass('show-minicart');
			      $('header.global nav.global #cart #status').addClass('hide');			       
			      $('header.global nav.global #cart #count').html('0');			       
		       }			       
		    },
		    error: function(XMLHttpRequest, textStatus) {
			    console.log(textStatus);
				$('#minicart footer .button').click();
		    }
		  })
	 	 e.preventDefault();
    });	
	/*if(!$('#wrapper').hasClass('shopify-wrapper') && $('.drop#shop .left.container.first *').length == 0){
		$.ajax({
			url:'https://shop.ceremonycoffee.com/pages/nav',
			success:function(data){
				$data = $(data);
				$cats = $data.find('#cats');
				$('#mobile-menu .shop-btn, .drop#shop .left.container.first').append($cats);
				$('#mobile-menu .shop-btn').find('#cats').append(' <li><a href="#">Gift Card</a></li>');			
				$('#mobile-menu .shop-btn').find('#cats').append(' <li><a href="https://ceremonycoffee.com/color/">Taste By Color</a></li>');			
				$('#mobile-menu .shop-btn').find('#cats').append(' <li><a href="https://shop.ceremonycoffee.com/">View All</a></li>');			
				$(document).find('.global #mobile-menu .parent > a, .global #mobile-menu .menu-item-has-children > a').each(function(){
					$(this).attr('href','#');
				});
				
			},
			error:function(){
				$('.drop#shop').remove();
				$('#menu-item-342').removeClass('parent');
			}      
		});		
	}*/
	$(document).find('.global #mobile-menu .parent > a, .global #mobile-menu .menu-item-has-children > a').each(function(){
		$(this).attr('href','#');
	});	
	if($('.grid.events.upcoming').length >= 1){	
		/*$.ajax({
			url:'https://shop.ceremonycoffee.com/search?page=1&q=events&view=json',
			dataType:'jsonp', 
			success:function(data){
				$data = $(data);
				$events = $data.find('.grid.list.events figure');
				$p = 0;
				$($events).each(function(){
				   if( $(this).attr('data-exp') < date.yyyymmdd()){
					   $(this).addClass('past');
					   $p++;
				   }
				});	
				var events = $events.detach().get();
				events.sort(function(a, b) {
					return new Date($(a).attr('data-date')) - new Date($(b).attr('data-date'));
				});
				$e = 1;
				//events.reverse()
				$(events).each(function(){
					
					if($e < 3 && !$(this).hasClass('past')){
						$e++;
						$('.grid.events.upcoming').append($(this));	
					}	
				})
				if(events.length === $p){
					$('.grid.events.upcoming').addClass('hide');
				}
			},
			error:function(){
				$('.grid.events.upcoming').addClass('hide');
			}      
		});*/	
				$('.grid.events.upcoming').addClass('hide');
	}
	/*if($('.grid.events.upcoming').length >= 1){	
		//$('.grid.events.upcoming').addClass('hide');
		$length = $eventresults.products.length;
		for (var i = 0; i < $length; i++) {	  
			//https://b7ccd3b07554f7c27b4f87fea804f98a:2849776d22bcc942636969b152e3a712@ceremony-coffee.myshopify.com/admin/products.json?collection_id=445832277&limit=20
			console.log($eventresults.products[i]);
		} 
	   //var results   = $("#events-template").html(),
            //templateResults = Handlebars.compile(results),
           // eventsHTML = templateResults($eventresults);
       //$('.grid.events.upcoming').append(eventsHTML);		
	}*/

	if($('.search-results').length >= 1 && $results != ''){
	   var results   = $("#results-template").html(),
            templateResults = Handlebars.compile(results),
            resultHTML = templateResults($results);
       $(resultHTML).insertAfter('.search-results header');
	   $('.search-results').find('article').each(function(){
		   if($(this).attr('data-content')){
			  $data = $(this).attr('data-content').toLowerCase();
			  if($data.indexOf('renew') <= 0 && $data.indexOf('recharge') <= 0 && $data.indexOf($query.toLowerCase()) >= 0){
				  $(this).removeClass('hidden')
			  }				   
		   }
	   });
	   if($('.search-results .shop:not(.hidden)').length >= 1){
		   $searchCount = parseInt($('#search-count').html());
		   if($searchCount === 0){
			   $('.search-results .nothing').addClass('hidden');
			   $('#search-count').html($('.search-results .shop:not(.hidden)').length);
		   } else{
			   $('#seach-count').html($searchCount + $('.search-results .shop:not(.hidden)').length);
		   }
	   }
	}
	if($('#pdp-top-sellers.gear').length >= 1){
	   var gearTemplateSource   = $("#gear-template").html(),
            templateGear = Handlebars.compile(gearTemplateSource),
            gearHTML = templateGear($gear);
       $('#pdp-top-sellers.gear').html(gearHTML);
	}	


	$(document).on('click','.rc_label__autodeliver',function(e){
		if($(this).parents('.rc_block').hasClass('rc_block__type--active')){
			$(this).parents('.rc_block').removeClass('rc_block__type--active');
			$('.rc_label__onetime').click();
			$(this).html('subscribe');
			e.preventDefault();
		} else{
			$(this).html('');
		}
	});
	$('#pdp-details-menu .link').click(function(){
		$id = $(this).attr('data-id');
		$('#pdp-details-info li').removeClass('shown');		
		$('#pdp-details').addClass('expanded');
		$('#pdp-details-info li#'+$id).addClass('shown');
	});
	$('#pdp-details .icon-cancel, #pdp-details-info').click(function(){
		$('#pdp-details').removeClass('expanded');
		setTimeout(function(){
			$('#pdp-details-info li').removeClass('shown');		
		},400);
	});
	if($('.filter .options').length >=1){
		$('.filter .options').each(function(){
		
		});
	}
	if($('.form').length >= 1){
		$('.gform_wrapper').each(function(){
			$id = $(this).attr('id');
			$action = $(this).find('form').attr('action');
			if($action.indexOf('?form') <= -1 ){
				$(this).find('form').attr('action',$action+'?form='+$id);			
			}
		});
		if(window.location.href.indexOf('form=') > -1) {
	    	$form = getQueryVariable('form');
			scrollbar.scrollTo(0, ($('.form').offset().top - 200), 1000)
	    }
	    //gform_confirmation_wrapper 
    }
	$(document).on('click','.global #mobile-toggle .icon', function(){	
		if($('body').hasClass('show-mobile-menu')){
			$('body').removeClass('show-mobile-menu');
		} else{
			$('body').addClass('show-mobile-menu');
		}
		clearTimeout($overlayTimeout);
	});
	$(document).on('click','.global #mobile-menu .parent > a, .global #mobile-menu .menu-item-has-children > a', function(e){	
		if($(this).parent('li').hasClass('expand')){
			$(this).parent('li').removeClass('expand');
		} else{
			$(this).parent('li').addClass('expand');
		}
		e.preventDefault();

	});
	$(document).on('mouseenter','.global .main .parent', function(){	
		clearTimeout($menuEnterIntent);
		$menu = $(this).find('a').attr('rel');
		if(!$menu){
			$menu = $(this).attr('rel');
		}
		$('body').removeClass('show-minicart');
		clearTimeout($overlayTimeout);
		if($(document).find('header.global').length >= 1){
			$navH = $(document).find('header.global').outerHeight();
			$(document).find('header.global .drop .container').css('padding-top',$navH+'px');
		}	
		if($(document).find('.drop#'+$menu+' video').length >= 1){
			$(document).find('.drop#'+$menu+' video').each(function(){
				if(!$(this).hasClass('loaded')){
					$(this).find('source').attr('src',$(this).attr('data-src'));
					$(this).get(0).load();	
					$(this).addClass('loaded');
					if(!isIE11){
						$(this).get(0).oncanplay = function() {
							$(this).parents('.card').addClass('video-loaded');
							if($(this).get(0).paused){
								$(this).get(0).play();
							}
						};
					} else{
						$(this).get(0).play();
					}

				} else{
					if(!isIE11){
						$(this).get(0).currentTime = 0;
						if($(this).get(0).paused){
							$(this).get(0).play();
						}	
					} else{
						$(this).get(0).play();
					}				
				}
			});
		}	
		$menuEnterIntent = setTimeout(function(){
			$('body').addClass('show-drop');
			$(document).find('.drop#'+$menu).addClass('shown');
			$(document).find('.drop:not(#'+$menu+')').removeClass('shown');			
		},500);		
	});
	$(document).on('click','.global .main .parent', function(){	
		clearTimeout($menuEnterIntent);	
		clearTimeout($dropLeaveIntent);	
		$('.drop').removeClass('shown');
		$('body').removeClass('show-drop');
		if($(document).find('.drop#'+$menu+' video').length >= 1){
			$(document).find('.drop#'+$menu+' video').each(function(){
				if(!isIE11){
					if(!$(this).get(0).paused){
						$(this).get(0).pause();
					}
				}
			});
		}
	});
	$(document).on('click','.global .search-button', function(){	
		$menu = $(this).find('a').attr('rel');
		if(!$menu){
			$menu = $(this).attr('rel');
		}
		if($(document).find('header.global').length >= 1){
			$navH = $(document).find('header.global').outerHeight();
			$(document).find('header.global .drop .container').css('padding-top',$navH+'px');
		}		
		//$menuEnterIntent = setTimeout(function(){
			$('body').addClass('show-drop');
			$('.drop#'+$menu).addClass('shown');
			$('.drop:not(#'+$menu+')').removeClass('shown');			
		//},500);		
	});
	$(document).on('click','.global #cart a', function(e){
		Scrollbar.get($('#minicart #minicart-wrapper')[0]).setPosition(0, 0);
		$('body').addClass('show-minicart');
		e.preventDefault();
	});
	$(document).on('click','.close-minicart', function(){
		$('body').removeClass('show-minicart');
	});
	$(document).on('click','.veil.full', function(){
		$('body').removeClass('show-minicart');
	});
	$(document).on('mouseleave','.global .main .parent', function(){	
		clearTimeout($menuEnterIntent);	
		clearTimeout($dropLeaveIntent);	
		$dropLeaveIntent = setTimeout(function(){
			$('.drop').removeClass('shown');
			$('body').removeClass('show-drop');
			if($(document).find('.drop#'+$menu+' video').length >= 1){
				$(document).find('.drop#'+$menu+' video').each(function(){
					if(!isIE11){
						if(!$(this).get(0).paused){
							$(this).get(0).pause();
						}
					}
				});
			}	
		},500);		
	});
	$(document).on('mouseleave','.global .drop', function(){
		clearTimeout($dropLeaveIntent);	
		$dropLeaveIntent = setTimeout(function(){
			$('.drop').removeClass('shown');
			$('body').removeClass('show-drop');
		},500);
	});
	$(document).on('mouseenter','.global .drop', function(){
		clearTimeout($dropLeaveIntent);	
	});
	$(document).on('click','#mobile-details .more-info', function(){
		$('#mobile-details').addClass('expand');
	});
	$(document).on('click','#mobile-details .hide-info', function(){
		$('#mobile-details').removeClass('expand');
	});
	$(document).on('click','form .icon-search',function(){
		$(this).parents('form').find('input[type=submit]').click();
	});
	$(document).on('click','#search-form .icon-cancel', function(){
		$(document).find('.drop').removeClass('shown');
		$('body').removeClass('show-drop');
		clearTimeout($dropLeaveIntent);
		clearTimeout($menuEnterIntent);	
	});
	$(document).on('click','header.global #alert .icon *, header.global #alert .icon', function(){
		$(document).find('.global #alert').addClass('closed');
		$('#wrapper').removeClass('alert-shown');
		$('.nudge').removeClass('nudge');
	});
	//$('.stretched').anystretch();  
	if($('.cards .slick').length >= 1){
		$('.cards .slick').slick({
			arrows : false,
			autoplay : false,
			infinite : false,
			fade : false,
			slide : 'figure',
			speed : 600,
			slidesToShow: 2,
			responsive: [{
				breakpoint: 1024,
				settings: {
					fade: false,
					centerMode: true,
					slidesToShow: 1,
					speed : 600
				}
			
			}]			
		});
	}
	if($('#hero').length >= 1){
		if($('#hero article').length > 1){
			$('body').addClass('hero-start');
			$('#hero').append('<span class="next cycle-nav"></span><span class="prev cycle-nav"></span>');
			$(document).on('click','.cycle-nav.next', function(){
				if(!$('body').hasClass('hero-end')){
					$('#hero').slick('slickNext');				
				}
			});
			$(document).on('click','.cycle-nav.prev', function(){
				if(!$('body').hasClass('hero-start')){
					$('#hero').slick('slickPrev');
				}
			});
		}
		$('#hero.slick').slick({
			arrows : false,
			autoplay : true,
			infinite : false,
			fade : true,
			slide : 'article',
			speed : 1000,
			responsive: [{
				breakpoint: 1025,
				settings: {
					fade: false,
					autoplay: false,
					speed : 1000
				}
			
			}]			
		});
		$('.slick').on('afterChange', function(event, slick, currentSlide){
			if(currentSlide === 0){
				$('body').addClass('hero-start');
				$('body').removeClass('hero-end');
			} else if(currentSlide === ($('#hero article').length - 1)){
				$('body').removeClass('hero-start');
				$('body').addClass('hero-end');				
			} else{
				$('body').removeClass('hero-start');
				$('body').removeClass('hero-end');												
			}
			if($('#hero .slick article[data-slick-index='+currentSlide+']').hasClass('invert')){
				$('body').addClass('invert-nav');
			} else{
				$('body').removeClass('invert-nav');				
			}
		});
	}
	if($('section.taste').length >= 1){
		$('.taste aside').click(function(){
			$('.taste').addClass('started');
		});
		$('.taste').slick({
			arrows : false,
			autoplay : false,
			infinite : false,
			fade : false,
			slide : 'article',
			speed : 2000,
			slidesToShow: 1,		
		});
		$('.taste').css('background-color',$('.taste .slick-current').attr('data-bg'));
		$('.pager li:nth-of-type(1)').addClass('selected');
		$('.taste').on('afterChange', function(currentSlide){
			//$('.taste').css('background-color',$('.taste .slick-current').attr('data-bg'));
		});
		$('.taste').on('beforeChange', function(event, slick, currentSlide, nextSlide){
			$('.pager li.selected').removeClass('selected');
			$('.pager li:nth-of-type('+ (nextSlide + 1) +')').addClass('selected');
			bg = $('.taste .slick-slide[data-slick-index='+nextSlide+']').attr('data-bg')
			$('.taste').css('background-color',bg);
		});
		$('section.taste .pager li').on('click', function(){
			$('.taste')[0].slick.slickGoTo( parseInt($(this).attr('data-count')-1) );			
			$('.pager li.selected').removeClass('selected');
			$(this).addClass('selected');
		});
		$('section.taste .next').click(function(){
			$nth = parseInt($(this).attr('data-id'));
			$('.taste')[0].slick.slickGoTo( parseInt($nth) );			
		});		

		c =1;
		$totalColors = $('.taste aside figure').length;

		//$('.taste aside figure:nth-of-type(1)').addClass('current');
		if($totalColors > 1){
			c = Math.floor(Math.random() * $totalColors) + 1; 
			$('.taste aside figure.current').removeClass('current');
			$('.taste aside figure:nth-of-type('+c+')').addClass('current');

			setInterval(function(){
				c = Math.floor(Math.random() * $totalColors) + 1; 
				//$('body').attr('id','color-'+$c);
				$('.taste aside figure.current').removeClass('current');
				$('.taste aside figure:nth-of-type('+c+')').addClass('current');
			}, 4000);			
		}	
		canvas = document.getElementById("colorCanvas");
		canvas.width = $('.taste').width();
		canvas.height =  $('.taste').height();
		createProton();
		tick();
	}
	if($('.tbc-banner').length >= 1){
		canvas = document.getElementById("colorCanvas");
		canvas.width = $('.tbc-banner').width();
		canvas.height =  $('.tbc-banner').height();
		c = 0;
		$totalColors = $('.tbc-banner figure').length;
		c = Math.floor(Math.random() * $totalColors) + 1; 
		$('.tbc-banner figure.current').removeClass('current');
		$('.tbc-banner figure:nth-of-type('+c+')').addClass('current');
		if($totalColors > 1){
			setInterval(function(){
				c = Math.floor(Math.random() * $totalColors) + 1; 
				$('.tbc-banner').css('background-color',$('.tbc-banner figure:nth-of-type('+c+')').attr('data-color'));
			}, 1500);			
		}	
		createProton();
		tick();	
	}
	$('.callout').click(function(e){
		window.location.href = $(this).find('.cta').attr('href');
	});
	if($('.grid.events.list').length > 0){
		$('.grid.events.list figure').each(function(){
		   if( $(this).attr('data-exp') < date.yyyymmdd()){
			   $(this).addClass('past');
		   }
		});	
		var grid = $('.grid.events.list');
		var events = grid.children('figure').detach().get();
		
		events.sort(function(a, b) {
			return new Date($(a).attr('data-date')) - new Date($(b).attr('data-date'));
		});
		grid.append(events);	
		if($('.grid.events.list figure:not(.past)').length < 1 || $('.grid.events.list figure').length < 1 ){
			$('.grid.events.list').addClass('no-events');
			$('.coffee-breaks.cta, .coffee-labs.cta').addClass('hide');
		} 	   
	}
	if($('form.event-form').length > 0){
		if($('form.event-form').attr('data-date') < date.yyyymmdd()){
			$('form.event-form').addClass('past');
		}
	}
	$('#pcp-coffee .bucket .cta').click(function(){
		//scrollbar.scrollIntoView($('#pcp-feature')[0]);
	});	
	$('.cta.scroll').click(function(e){
		$next = $(this).parents('section').offset().top + $(this).parents('section').height();
		//console.log($next);
		if($next){
			//scrollbar.scrollTo(0, $next, 1000)
			//scrollbar.scrollIntoView($next);
		}
		
		e.preventDefault();
	});	
	$('.scroll-subscribe').click(function(){
		//scrollbar.scrollIntoView($('#subscription-builder')[0]);
	});	
	$('#pcp-feature .cta').click(function(){
		//scrollbar.scrollIntoView($('#pcp-gear')[0]);
	});	
	$('.cta.coffee-breaks').click(function(){
	//	scrollbar.scrollIntoView($('.grid.events.list')[0]);
		$('.filter li[data-filter=tag-coffee-break]').click();
	});
	$('.cta.coffee-labs').click(function(){
		//scrollbar.scrollIntoView($('.grid.events.list')[0]);
		$('.filter li[data-filter=tag-coffee-lab]').click();
	});
	$('.cta.guides').click(function(){
		//scrollbar.scrollIntoView($('.grid.guide.list')[0]);
	});	
	$(document).find('.jump select').on('change', function () {
          var url = $(this).val(); 
          if (url) { 
              window.location = 'https://shop.ceremonycoffee.com/'+url; 
          }
          return false;
      });	
    $(document).on('click','#newsletter', function(){
	    if($(this).hasClass('default')){
		    clearTimeout($focusTimeout);
			$('#newsletter.default').addClass('form').removeClass('default'); 
			$focusTimeout = setTimeout(function(){
				$form.find('input[type=email]').focus();
			},600);	    
	    }
    });
    if ($form.length > 0) {
        $form.bind('submit', function (e) {
			register($form);
			e.preventDefault();
        });
    }
 	$form.find('input[type=email]').bind('input propertychange', function() {
		if (testEmail.test($(this).val())){
			$form.find('input[type=submit]').prop("disabled", false);
         } else {
			$form.find('input[type=submit]').prop("disabled", true);
         }
	});       
    $(document).on('click','#newsletter-response, #newsletter-response span', function(e){
		if($('#newsletter').hasClass('error')){
			$('#newsletter').attr('class','form');		
		} else{
			$('#newsletter').attr('class','default');
		}
		e.stopPropagation();
	});
	$(document).on('mouseenter click','.filter', function(){
		if($(this).hasClass('expand')){
			$(this).removeClass('expand');
		} else{
			$('.filter.expand').removeClass('expand');
			$(this).addClass('expand');
		}	
	});
	$(document).on('mouseleave','.filter', function(){
		$(this).removeClass('expand');
	});
	if($('.filters .filter:not(.sort) .options li').length > 1){
		$('.filters .filter:not(.sort) .options li').each(function(){
			if($(this).parents('section').find('.filterable.'+$(this).attr('data-filter')).length == 0){
				$(this).addClass('hidden');
			}
		});		
	}
    $(document).on('click','.filter:not(.sort) .options li', function(){
	    $this =  $(this);
		//scrollbar.scrollIntoView($this.parents('section')[0]);			
	    $this.parents('section').find('.filters .scroll-content').css('transform','translate3d(0,0,0)');
		$filters = '';
		$this.parents('section').find('.filterable').removeClass('show');	    
	    if($this.hasClass('active')){
			$this.removeClass('active');
	    } else{
		    $this.parents('.options').find('li.active').removeClass('active');
			$this.addClass('active');
	    }
		if($this.parents('section').find('.filter .active').length < 1){
			$this.parents('section').removeClass('filtered');
		} else{
			$this.parents('section').addClass('filtered');
		}
		$this.parents('.filters').find('.filter:not(.expand) .options li:not(.active)').each(function(){
			if($this.parents('section').find('.filterable.'+$(this).attr('data-filter')+'.'+$this.attr('data-filter')).length == 0){
				$(this).addClass('hide');
			} else{
				$(this).removeClass('hide');				
			}
		});
	    $('.filter').removeClass('expand');	  
	    $this.parents('section').find('.filters .active').each(function(){
			$filters += '.'+$(this).attr('data-filter');
	    });
	    $this.parents('section').find('.filter').each(function(){
		    if($(this).find('.active').length > 0){
			    $(this).find('.selected').html($(this).find('.active').html());		    		    
		    } else{
			    $(this).find('.selected').html($(this).find('.selected').attr('data-reset'));
		    }
	    });
		if($filters != '' && $this.parents('section').find('.filterable'+$filters).length > 0){
		    $this.parents('section').find('.filterable'+$filters).addClass('show');
			$this.parents('section').find('header hgroup p').html('Results ('+$(this).parents('section').find('.filterable'+$filters).length+')');
		} else{ 
		    $this.parents('section').find('header hgroup p').html($(this).parents('section').find('header hgroup p').attr('data-reset'));	
		    $this.parents('section').find('.filters .filter .options li.hide').removeClass('hide');	 
		    $this.parents('section').find('.filter').each(function(){
				$(this).find('.selected').html($(this).find('.selected').attr('data-reset'));
		    });		  
		    $this.parents('.options').find('li.active').removeClass('active');
		    $this.parents('section').removeClass('filtered');     
		    $this.parents('section').find('.filterable').removeClass('show');			
		}
    });
    $(document).on('click','.filter.sort .options li', function(){
	    $('.filter').removeClass('expand');	  
		$(this).parents('section').find('figure').addClass('visible');	 
	    if($(this).hasClass('active')){
			$(this).removeClass('active');
			$(this).parents('section').find('.filterable').sort(function (a, b) {
				return +a.getAttribute('data-original') - +b.getAttribute('data-original');
			})
			.appendTo( $(this).parents('section') );    
	    } else{
			$(this).parents('.options').find('li.active').removeClass('active');
			$(this).addClass('active');
		    if($(this).hasClass('price-low')){
				$(this).parents('section').find('.filterable').sort(function (a, b) {
					return +a.getAttribute('data-price') - +b.getAttribute('data-price');
				})
				.appendTo( $(this).parents('section') );    
		    } else{
				$(this).parents('section').find('.filterable').sort(function (a, b) {
					return +a.getAttribute('data-price') + +b.getAttribute('data-price');
				})
				.appendTo( $(this).parents('section') );  	    
		    }
	    }
	});
	if($('#pdp-hero').length >= 1 && $('#pdp-object').length >= 1){
		if($('#wrapper').hasClass('alert-shown')){
			$('#pdp-object img').addClass('nudge');
		}
		TweenLite.set($('#pdp-object img'), {top:'50%', left:'55%', x:'-90%', y:'-50%',rotation:0, scale: 1});
		tl = new TimelineMax({paused: true});
		tl.fromTo($('#pdp-object img'), 1, {top:'50%', left:'55%', x:'-90%', y:'-50%',rotation:0, scale: 1}, {top:'50%', left:'50%', x:'-50%', y:'-50%',rotation:0, scale:0.6});
	} else if($('#pdp-hero').length >= 1 && $('#pdp-object-gear').length >= 1){
		if($('#wrapper').hasClass('alert-shown')){
			$('#pdp-object-gear img').addClass('nudge');
		}		
	}
	if($('#pdp-colors').length > 0){
		c = 0;
		$totalColors = $('#pdp-colors article figure').length;
		$('#pdp-colors article figure:nth-of-type(1)').addClass('current');
		if($totalColors > 1){
			setInterval(function(){
				c++;
				if(c > $totalColors){
					c = 1;
				}
				$('#pdp-colors article figure.current').removeClass('current');
				$('#pdp-colors article figure:nth-of-type('+c+')').addClass('current');
			}, 2000);			
		}
	}

	$('.subscription-card .button.subscribe').click(function(e){
		$id = $(this).attr('data-id');
		if($('.subscribe-form.show .scroll-content').length >= 1){
			//Scrollbar.destroy($('.subscribe-form.show')[0]);
		}
		$('.subscribe-form.show').removeClass('show');
		$('.subscribe-form#'+$id).addClass('show');
		/*var subscriptionScroll = Scrollbar.init($('.subscribe-form.show')[0], {
			speed: .6,
			damping: 0.1,
			renderByPixels: true,
			syncCallbacks: true,
			continuousScrolling: false,
			overscrollEffect: false
		});	*/
		$('.subscribe-form#'+$id).find('.rc_label__autodeliver').click();
		if($('#subscription-builder').offset().top > 0){
			//Scrollbar.get($('#main-scrollbar')[0]).scrollIntoView($('#subscription-builder .card:first-of-type')[0]);
		}
		if($('footer.global').offset().top < $(window).height()){
			$stack = $('#hero').outerHeight() + $('#three-col').outerHeight() + $('#callout').outerHeight() + $('#subscription-builder').outerHeight() - $(window).height();
			//Scrollbar.get($('#main-scrollbar')[0]).scrollIntoView($('#subscription-builder')[0]);
		}
		e.preventDefault();
	});
	$('.subscription-card .target').click(function(e){
		$(this).parents('.card').find('.button.subscribe').click();
		e.preventDefault();
	});	
	$('.subscribe-form .cancel').click(function(e){
		$('.subscribe-form').removeClass('show');
		e.preventDefault();
	});
	
}

$(window).bind('pageshow', function(event) {
	 if (event.originalEvent.persisted) {
     loadScripts();
     }
});
window.onunload = function(){};

function loadScripts(){
		$winW = $(window).width();
	$winH = $(window).height();
	setStage($winW, $winH);
	$('.background-video').each(function(){
		$(this).find('source').attr('src',$(this).attr('data-src'));
		//$(this).get(0).load();	
		if(!isIE11){
			$(this).get(0).oncanplaythrough = function() {
				$(this).parents('section').addClass('video-loaded');
			};			
		}
	});
	if(!$('#global-overlay').hasClass('disabled')){
		if(getQueryVariable('ref') === 'shown' && !$('body').hasClass('home')){
			createCookie('shownOverlay', 'true', 90);
			clearTimeout($overlayTimeout);
			addRefToLinks();
			$shownOverlay = true;
		} else if(getQueryVariable('ref') === 'shown' && $('body').hasClass('home')){
			addRefToLinks();
			$shownOverlay = true;
		} else{
			$shownOverlay = getCookie('shownOverlay');
			//console.log('shownOverlay: '+$shownOverlay);
		}
		if(!$shownOverlay){
			$delay = $('#global-overlay').attr('data-delay');
			showOverlay($delay);
		} else{
			addRefToLinks();
			$('#global-overlay').addClass('disabled');
		}
	}

	if($('.has-video video').length >= 1){	
		$('.has-video').each(function(){
			if(!$(this).find('video').hasClass('started')){
				$(this).find('video').addClass('started');
				$vidEl2 = $(this).find('video').get(0);
				if(!isIE11){
					$vidEl2.currentTime = 0;
					if($vidEl2.paused){
						$vidEl2.play();
					}						
				} else{
					$vidEl2.play();
				}					
			}	
		})	
	}	
	$('body img').each(function(){
		if($(this).is(':visible')){
			$(this).hide().show(0);		
		}
	});
	$('body').addClass('loaded');	
	if($('.subscribe-form').length >= 1){
		$('.subscribe-form').each(function(){
			$(this).find('.rc_block__type__autodeliver').addClass('rc_block__type--active');
			if($(this).find('.rc_block__type__autodeliver').length >= 1){
				console.log('found');
				$(this).find('.rc_label__autodeliver').click();
			}
			//$(this).find('.rc_label__autodeliver').click();
		});
		
	}
}
$(window).on('load',function(){
	loadScripts();
})
.resize(function(){
	$winW = $(window).width();
	$winH = $(window).height();	
	setStage($winW, $winH);
});
$(document).on('click', '#close-overlay', function(e){	
	$('body').removeClass('show-overlay');
	e.preventDefault();
});
$(document).on('click', '#overlay-veil', function(e){	
	$('body').removeClass('show-overlay');
	e.preventDefault();
});
function showOverlay(delay){
	$delay = delay * 1000;
	clearTimeout($overlayTimeout);
	$overlayTimeout = setTimeout(function(){
		if( !$('body').hasClass('show-minicart') && !$('body').hasClass('show-drop') && !$('body').hasClass('leaving') && $('body').attr('id') !== 'account' && $('body').attr('id') !== 'create-account'  && $('body').attr('id') !== 'your-shopping-cart' ){
			if($('body').hasClass('home')){
				addRefToLinks();
			} else{
				
				addRefToLinks()
				createCookie('shownOverlay', 'true', 90);
			}
			$('body').addClass('show-overlay');
		}
	},$delay);
}

function addRefToLinks() {
  $('body a').not('[href^="#"]').each(function() {
	var $this = $(this);       
	var _href = $(this).attr("href");
	
	if (!_href) return; // Skip if href is undefined
	
	var arr = _href.split('?');
	if(!getUrlParameter('ref')) {
	  if (arr.length > 1 && arr[1] !== '') {
		$(this).attr("href", _href + '&ref=shown');
	  } else {
		$(this).attr("href", _href + '?ref=shown');
	  }
	}
  });
}
var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};
function scrollStuff($scrolled){
	$navH = $(document).find('header.global').outerHeight();
	$('#main-scrollbar .fixed').css('top',$scrolled + 'px');
	if($scrolled > $navH){
		$(document).find('header.global .veil').css('max-height',$navH);
		$(document).find('header.global').addClass('sticky');
	} else{
		$(document).find('header.global .veil').css('max-height',$scrolled*1.5);		
		$(document).find('header.global').removeClass('sticky');
	}
	if($scrolled/5 <= $(document).find('#alert').outerHeight() && !$(document).find('#alert').hasClass('closed') && $(document).find('#alert').is(':visible')){
		$(document).find('header.global').css('transform','translateY('+$scrolled/5 * -1+'px)');
		$(document).find('.nudge').css('margin-top',$scrolled/5 * -1+'px');
	} else if(!$(document).find('#alert').hasClass('closed') && $(document).find('#alert').is(':visible')){
		$(document).find('header.global').css('transform','translateY('+$(document).find('#alert').outerHeight()*-1 +'px)');		
		$(document).find('.nudge').css('margin-top',$('#alert').outerHeight() * -1+'px');
	}
	
	if($('#hero').length >= 1){
		$(document).find('#hero img').css('top',$scrolled/5+'px');
		if($(document).find('#hero video').length >= 1){
			$(document).find('#hero video').css('margin-top',$scrolled/5+'px');			
		}
	}
	if($('#pdp-hero').length >= 1 && $('#pdp-object').is(':visible') && $('#pdp-intro h1').length >= 1){
		if(tl){
			var progress = tl.totalProgress();
			var pct = $scrolled / ($winH/1.5);
			tl.progress(pct);
		}
		if($('#pdp-object').length >= 1){
			if($('#pdp-intro').offset().top + $('#pdp-intro article').outerHeight() - $('.object').height()/2 < 0){
				$stopObject = true;
			} else{
				$stopObject = false;
			}
		}
		if($('#pdp-colors').length >= 1){
			if($('#pdp-colors').offset().top < $winH/6){
				$('#pdp-details').addClass('stop');
				$stopOrder = true;
			} else{
				$('#pdp-details').removeClass('stop');	
				$stopOrder = false;		
			}
		} else{
			if($('#pdp-intro').length >= 1){
				if($('#pdp-intro').offset().top + $('#pdp-intro article').outerHeight() - $('.object').height()/2 < 0){
					$('#pdp-details').addClass('stop');
					$stopOrder = true;	
				} else{
					$('#pdp-details').removeClass('stop');		
					$stopOrder = false;	
				}							
			} else{
				$('#pdp-details').removeClass('stop');		
				$stopOrder = true;					
			}
		}
		$('#hero-fill').css('opacity',1-$scrolled/($('#hero-fill').height()/2));
		if(!$stopOrder){
			$('.order').css('top',$scrolled + 'px');	
		}
		if(!$stopObject){
			$('.object').css('top',$scrolled + 'px');	
		}
	}
	if($('.subscribe-form').length > 0){
		if($('#subscription-builder').offset().top < 0){
			if($('#subscription-builder').offset().top > ($('#subscription-builder').outerHeight() * -1 + $(window).height())){
				$('.subscribe-form').css('top',parseFloat($('#subscription-builder').offset().top) *-1 + 'px');		
			}
		} else{
			$('.subscribe-form').css('top', '0px');
		}
	}
	$(document).find('.global .drop.shown').removeClass('shown');
	$('body').removeClass('show-drop');
	$('body').removeClass('show-mobile-menu');
	$('body').removeClass('show-minicart');
    $('section').each(function(){
	    $this = $(this)[0];
		if($(this).offset().top < $winH/1.5){
			$(this).addClass('on-screen');
			if($(this).hasClass('video-loaded')){
				if(!$(this).find('.background-video').hasClass('started')){
					$(this).find('.background-video').addClass('started');
					$vidEl = $(this).find('.background-video').get(0);
					if(!isIE11){
						$vidEl.currentTime = 0;
						if($vidEl.paused){
							$vidEl.play();
						}
					} else{
						$vidEl.play();
					}								
				}
			}
			if($(this).find('.has-video').length >= 1){
				if(!$(this).find('.has-video video').hasClass('started')){
					$(this).find('.has-video video').addClass('started');
					$vidEl2 = $(this).find('.has-video video').get(0);
					if(!isIE11){
						$vidEl2.currentTime = 0;
						if($vidEl2.paused){
							$vidEl2.play();
						}			
					} else{
						$vidEl2.play();
					}								
				}
			}
		}
    });	
    $('.parallax').each(function(){
	    $offset = $(this).attr('data-offset');
	    $(this).css('transform', 'translateY('+ (-(($scrolled - $offset) * .08)) + 'px)');
    });
    if($('.card-grid').length >= 1){
	    $('.card-grid figure').each(function(){
		   if($(this).offset().top < $winH){
			   $(this).addClass('visible');
		   }
	    });
    }
}
function setStage($winW, $winH){
	if($(document).find('header.global').length >= 1){
		$navH = $(document).find('header.global').outerHeight();
		$(document).find('header.global .drop .container').css('padding-top',$navH+'px');
	}
    if($('.card-grid').length >= 1){
	    $('.card-grid figure').each(function(){
		   if($(this).offset().top < $winH){
			   $(this).addClass('visible');
		   }
	    });
    }
	$('.parallax').each(function(){
		$(this).attr('style','');
		$offset = $(this).offset().top;
		$(this).attr('data-offset',($scrolled) + $offset);
		$(this).css('transform', 'translateY('+ (-(($scrolled - $offset) * .08)) + 'px)');
	});
	if($('.filters .filter').length > 0){
		$('.filters .filter').each(function(){
			$(this).find('.selected').css('min-width',$(this).find('.selected').outerWidth());
		});
	}
	if($('#pdp-order form').length > 0 && $('#pdp-object').is(':visible')){
		if($('#pdp-order form').height() > $winH/2){
			$('#pdp-order').removeClass('order');
			$('#pdp-object').removeClass('object');
			$('div.product').addClass('short');
		} else{
			$('#pdp-order').addClass('order');			
			$('#pdp-object').addClass('object');
			$('div.product').removeClass('short');
		}	
	}
	if($('#pdp-hero').length >= 1 && $('#pdp-object').length >= 1){
		if($('#wrapper').hasClass('alert-shown')){
			$('#pdp-object img').addClass('nudge');
		}
		$('#pdp-object').addClass('show');

	} else if($('#pdp-hero').length >= 1 && $('#pdp-object-gear').length >= 1){
		if($('#wrapper').hasClass('alert-shown')){
			$('#pdp-object-gear img').addClass('nudge');
		}		
	}
	if($('section.taste').length >= 1){	
		canvas = document.getElementById("colorCanvas");
		canvas.width = $('.taste').width();
		canvas.height =  $('.taste').height();
		if(protonCreated){
			renderer.resize(canvas.width, canvas.height);
		}
	}	
	if($('.tbc-banner').length >= 1){
		canvas = document.getElementById("colorCanvas");
		canvas.width = $('.tbc-banner').width();
		canvas.height =  $('.tbc-banner').height();
		if(protonCreated){
			renderer.resize(canvas.width, canvas.height);
		}
	}
	scrollStuff($scrolled);
}
function createProton() {
	proton = new Proton;
	createImageEmitter();
	renderer = new Proton.Renderer('webgl', proton, canvas);
	renderer.blendFunc("ONE", "ONE");
	renderer.start();
	protonCreated = true;
}
function createImageEmitter() {
	emitter = new Proton.Emitter();
	emitter.rate = new Proton.Rate(new Proton.Span(0, 0), new Proton.Span(.01, .015));
	emitter.addInitialize(new Proton.Mass(1));
	emitter.addInitialize(new Proton.Life(.1,1));
	emitter.addInitialize(new Proton.ImageTarget([$templateDirectory+'/assets/images/particle.png'], 32));
	emitter.addInitialize(new Proton.Radius(7));
	emitter.addInitialize(new Proton.V(new Proton.Span(0, 0), 500, 'polar'));
	emitter.addBehaviour(new Proton.Alpha(1, 0));
	emitter.addBehaviour(new Proton.Color('#ffcc00', '#ffcc00'));
	emitter.addBehaviour(new Proton.Scale(4, 4));
	emitter.p.x = $(window).width() / 2;
	emitter.p.y = $(window).height() / 2;
	emitter.emit();
	proton.addEmitter(emitter);
}
function tick() {
	requestAnimationFrame(tick);
	proton.update();
}
$(document).on('keydown',function(e) {
    e = e || window.event;
    switch (e.keyCode) {
        case 27:
            $('body').removeClass('show-minicart');
            $('body').removeClass('show-drop');
            $('.subscribe-form.show').removeClass('show');
            $('.drop.shown').removeClass('shown');
            break;
    }
}).on('mousemove',function(e){
	if(e.pageX < $(window).width()*.1){
		if(!$('body').hasClass('hero-start')){
			$('body').addClass('mouse-left');
			$('body').removeClass('mouse-right');			
		} else{
			$('body').removeClass('mouse-left');
			$('body').removeClass('mouse-right');			
		}
	} else if(e.pageX > $(window).width()*.9){
		if(!$('body').hasClass('hero-end')){
			$('body').removeClass('mouse-left');
			$('body').addClass('mouse-right');
		} else{
			$('body').removeClass('mouse-left');
			$('body').removeClass('mouse-right');			
		}
	} else{
		$('body').removeClass('mouse-left');
		$('body').removeClass('mouse-right');
	}
	if($('section.taste').length >= 1 || $('.tbc-banner').length >= 1){
		if(protonCreated){
			if($('.tbc-banner').length >= 1){
				emitter.p.x = e.pageX - $('.tbc-banner').offset().left;
				emitter.p.y = e.pageY - $('.tbc-banner').offset().top;
			} else{
				emitter.p.x = e.pageX - $('section.taste').offset().left;
				emitter.p.y = e.pageY - $('section.taste').offset().top;
			}
			emitter.rate = new Proton.Rate(new Proton.Span(1, 3), new Proton.Span(.01, .01));
			clearTimeout($timer);
			$timer = setTimeout(function(){
				clearTimeout($timer);
				emitter.rate = new Proton.Rate(new Proton.Span(0, 0), new Proton.Span(.01, .01));
			},60);
		}
	}
}).on('touchmove',function(e){
	if($('section.taste').length >= 1 || $('.tbc-banner').length >= 1){
		if(protonCreated){
			touch =  e.originalEvent.touches[0];
			if($('.tbc-banner').length >= 1){
				emitter.p.x =  touch.clientX - $('.tbc-banner').offset().left;
				emitter.p.y =  touch.clientY - $('.tbc-banner').offset().top;
			} else{
				emitter.p.x =  touch.clientX - $('section.taste').offset().left;
				emitter.p.y =  touch.clientY - $('section.taste').offset().top;
			}
			emitter.rate = new Proton.Rate(new Proton.Span(1, 3), new Proton.Span(.01, .01));
			clearTimeout($timer);
			$timer = setTimeout(function(){
				clearTimeout($timer);
				emitter.rate = new Proton.Rate(new Proton.Span(0, 0), new Proton.Span(.01, .01));
			},60);
		}	
	}
});
function getQueryVariable(variable){
	var query = window.location.search.substring(1);
	var vars = query.split("&");
	for (var i=0;i<vars.length;i++) {
       var pair = vars[i].split("=");
       if(pair[0] == variable){return pair[1];}
	}
	return(false);
}
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
	var c = ca[i];
	while (c.charAt(0) == ' ') {
	  c = c.substring(1);
	}
	if (c.indexOf(name) == 0) {
	  return c.substring(name.length, c.length);
	} 
  }
  return "";
}
function createCookie(name, value, days) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + value + expires + "; path=/";
}	
function register($form) {
    $.ajax({
        type: $form.attr('method'),
        url: $form.attr('action'),
        data: $form.serialize(),
        cache       : false,
        dataType    : 'jsonp',
		jsonp: 'c',
        contentType: 'application/json; charset=utf-8',
        success     : function(data) {
	        //alert(data.result);
            if (data.result != "success") {
	            $form.parents('#newsletter').removeClass('form');
	            $form.parents('#newsletter').removeClass('success');
	            $form.parents('#newsletter').removeClass('default');
	            $form.parents('#newsletter').addClass('response');
	            $form.parents('#newsletter').addClass('error');
            } else {
	            $form.parents('#newsletter').removeClass('form');
	            $form.parents('#newsletter').removeClass('error');
	            $form.parents('#newsletter').removeClass('default');
	            $form.parents('#newsletter').addClass('response');
	            $form.parents('#newsletter').addClass('success');
            }
        }
    });
}

document.getElementById('gift_form').checkValidity()
document.getElementById('gift_form').reportValidity()